import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import Moment from "react-moment";
import Avatar from "components/Avatar";
import { FiMoreHorizontal } from "react-icons/fi";
import { Dropdown } from "react-bootstrap";
import EmployeeListItemHeader from "components/Employees/EmployeeListItemHeader";
import AbsenceListItemPeriod from "components/Absences/AbsenceListItemPeriod";
import * as workflowsActions from "actions/workflowsActions";
import { wfStatus } from "services/workflowsService";

class MyPreferences extends React.Component {
	getEmptyRow = () => {
		return <p className="no-results">{this.props.t("preferences.noResults")}</p>;
	};

	getRows = () =>
		this.props.employee_preferences.map((preference) => (
			<div className="col-sm-6 col-lg-4 col-xl-3" key={preference.id}>
				<article className="card card-ausencia" key={preference.id}>
					<EmployeeListItemHeader employee={preference.requester} />

					<div className="card-content">
						{/* <span className="absence-comments">{absence.comments}</span> */}

						<span
							className="card-shift"
							style={{
								backgroundColor:
									preference.shift.background_color &&
									preference.shift.background_color,
								borderColor:
									preference.shift.border_color &&
									preference.shift.border_color,
							}}
						>
							{preference.shift.name}
						</span>

						<AbsenceListItemPeriod absence={preference} />

						<p className="card-label card-label-solicitado">
							{this.props.t("preferences.requestedOn")}{" "}
							<Moment className="tag-dia" format="D/MM/YYYY">
								{preference.requested}
							</Moment>
						</p>

						<div className="form-group no-form">
							<span className={`estado ${preference.status}`}>
								{preference.status}
							</span>
						</div>

						{preference.answerer && (
							<div className="form-group no-form card-label-gestionado">
								<Avatar
									userId={preference.answerer.id}
									className="avatar-xxs"
									alt={preference.answerer.name}
									style={{ margin: "0px", marginRight: "8px" }}
								/>{" "}
								{preference.answerer.name} {preference.answerer.surname}
							</div>
						)}

						{preference.answer_comments && (
							<span className="absence-answer-comments">
								{preference.answer_comments}
							</span>
						)}

						<div className="card-actions bottom-right">
							<Dropdown>
								<Dropdown.Toggle variant="action">
									<FiMoreHorizontal />
								</Dropdown.Toggle>
								<Dropdown.Menu>
									{preference.status === wfStatus.pending ? (
										<Dropdown.Item
											as="button"
											onClick={() =>
												this.props.openEditPreferenceModal(preference)
											}
										>
											{this.props.t("common.edit")}
										</Dropdown.Item>
									) : (
										<Dropdown.Item
											as="button"
											onClick={() =>
												this.props.openEditPreferenceModal(preference, true)
											}
										>
											{this.props.t("common.view")}
										</Dropdown.Item>
									)}

									{preference.status !== wfStatus.denied &&
										preference.status !== wfStatus.canceled && (
											<Dropdown.Item
												as="button"
												onClick={() =>
													this.props.handleCancelRequest(preference)
												}
											>
												{this.props.t("preferences.cancelPreference")}
											</Dropdown.Item>
										)}
									{preference.status !== wfStatus.pending && (
										<Dropdown.Item
											as="button"
											onClick={() => this.props.handleReopenRequest(preference)}
										>
											{this.props.t("preferences.reopenPreference")}
										</Dropdown.Item>
									)}
								</Dropdown.Menu>
							</Dropdown>
						</div>
					</div>
				</article>
			</div>
		));

	render() {
		return (
			<>
				{this.props.employee_preferences.length === 0 ? (
					this.getEmptyRow()
				) : (
					<div className="row list-absences">{this.getRows()}</div>
				)}
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.shiftsReducer,
		...reducers.workflowsReducer,
		...reducers.employeesReducer,
		user: reducers.authReducer.user,
	};
};

export default connect(mapStateToProps, workflowsActions)(withTranslation()(MyPreferences));
